import React from 'react';
import { Modal, ModalProps } from '@edgebox/react-components';
import { modalClose, modalOpen, scrollToTop } from '../frame-messages';
import { AppParamsContext, IAppParams } from './AppParams';

// A host page that scrolls the frame with its own page sizes it to its content, so a dialog placed in
// the frame's viewport would sit somewhere down a frame as high as that content: such a host shows the
// frame over the whole window while the dialog is up, and puts it back once the dialog is closed or
// gone. Any other host scrolls to the frame's top, where the dialog is.
export function EmbeddedModal(props: ModalProps) {
  const scrolledByHost = !!(React.useContext(AppParamsContext) as IAppParams | null)?.hostScrollsFrame;
  const shownOverWindowRef = React.useRef(false);
  const { show } = props;

  React.useEffect(() => {
    if (show && scrolledByHost && !shownOverWindowRef.current) {
      shownOverWindowRef.current = true;
      modalOpen();
    } else if (!show && shownOverWindowRef.current) {
      shownOverWindowRef.current = false;
      modalClose();
    }
  }, [show, scrolledByHost]);

  React.useEffect(
    () => () => {
      if (shownOverWindowRef.current) {
        shownOverWindowRef.current = false;
        modalClose();
      }
    },
    []
  );

  const onShow = React.useCallback(() => {
    if (!scrolledByHost) {
      scrollToTop();
    }
  }, [scrolledByHost]);

  return <Modal {...props} onShow={onShow} />;
}
